import '../Home.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faFish, faAward, faTag, faUser, faLink } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

export default function LearnMoreCard() {
  return (
	<>
		<div className="card">
		  <h2>Want to learn more?</h2>
		  <a className="learn-more-link" href="#">
			<FontAwesomeIcon icon={faHouse} className="user-icon" />
			&emsp;
			FishTagged Homepage
		  </a>
		  <a className="learn-more-link" href="#">
			<FontAwesomeIcon icon={faInstagram} className="user-icon" />
			&emsp;
			FishTagged Instagram
		  </a>
		  <a className="learn-more-link" href="#">
			<FontAwesomeIcon icon={faUser} className="user-icon" />
			&emsp;
			The FishTagged Team & What We Do
		  </a>
		  <a className="learn-more-link" href="#">
			<FontAwesomeIcon icon={faTag} className="user-icon" />
			&emsp;
			How To Report A Tagged Fish
		  </a>
		  <a className="learn-more-link" href="#">
			<FontAwesomeIcon icon={faAward} className="user-icon" />
			&emsp;
			Rewards Program Information
		  </a>
		  <br />
		  <hr />
		  <br />
		  <i style={{"text-align": "center"}}>In line with FishTagged's STEM education mission, this app is 100% student written and operated.</i>
		</div>
	</>
  );
}
